import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/qrCode/qrCode1.png'


const _withScopeId = n => (_pushScopeId("data-v-6487d216"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "DisciplinePageBackground" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "disciplineName" }
const _hoisted_4 = { id: "mainBody" }
const _hoisted_5 = { id: "disciplinePageBodyContainer" }
const _hoisted_6 = { id: "disciplinePageBody" }
const _hoisted_7 = { id: "disciplinePageBodyLeft" }
const _hoisted_8 = {
  key: 2,
  class: "greyBackgroundContainer"
}
const _hoisted_9 = { class: "greyBackgroundText" }
const _hoisted_10 = { class: "employmentIndicatorsContainer" }
const _hoisted_11 = {
  key: 0,
  id: "line1Item1"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line1Item1Echart" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line1Item1Text" }, "毕业半年后的月收入", -1))
const _hoisted_14 = { id: "line1Item1Value1" }
const _hoisted_15 = { id: "line1Item1Value2" }
const _hoisted_16 = {
  key: 1,
  id: "line1Item2"
}
const _hoisted_17 = { id: "line1Item2EchartContainer" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line1Item2EchartLeft" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line1Item2EchartRight" }, null, -1))
const _hoisted_20 = { id: "line1Item2LeftValue" }
const _hoisted_21 = { id: "line1Item2RightValue" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line1Item2Text" }, "毕业半年后的就业率", -1))
const _hoisted_23 = {
  key: 4,
  class: "employmentIndicatorsContainer",
  id: "employmentIndicatorsLine2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line2Item1" }, null, -1))
const _hoisted_25 = { id: "line2Item1Value1" }
const _hoisted_26 = { id: "line2Item1Value2" }
const _hoisted_27 = { id: "line2Item1Value3" }
const _hoisted_28 = { id: "line2Item1Value4" }
const _hoisted_29 = { class: "employmentIndicatorsContainer" }
const _hoisted_30 = {
  key: 0,
  class: "line3Item"
}
const _hoisted_31 = { class: "line3ItemEchart" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart1" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart2" }, null, -1))
const _hoisted_34 = { id: "line3Item1LeftValue" }
const _hoisted_35 = { id: "line3Item1RightValue" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3ItemText" }, "留学比例", -1))
const _hoisted_37 = {
  key: 1,
  class: "line3Item"
}
const _hoisted_38 = { class: "line3ItemEchart" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart3" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart4" }, null, -1))
const _hoisted_41 = { id: "line3Item2LeftValue" }
const _hoisted_42 = { id: "line3Item2RightValue" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3ItemText" }, "升学比例", -1))
const _hoisted_44 = {
  key: 2,
  class: "line3Item"
}
const _hoisted_45 = { class: "line3ItemEchart" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart5" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "line3ItemEchart6" }, null, -1))
const _hoisted_48 = { id: "line3Item3LeftValue" }
const _hoisted_49 = { id: "line3Item3RightValue" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3ItemText" }, "升学转专业比例", -1))
const _hoisted_51 = { id: "disciplinePageBodyRight" }
const _hoisted_52 = {
  key: 1,
  id: "majorTargetRank"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "•", -1))
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { id: "disciplinePageFooter" }
const _hoisted_56 = { id: "footerLeft" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "footerLeftTitle" }, "系统使用说明", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "footerRight" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footerRightItem" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))

import LeftTitle from '@/components/collegeSituation/LeftTitle.vue'
  import RightTitle from '@/components/collegeSituation/RightTitle.vue'
  import {ref, reactive, nextTick, onMounted, computed} from 'vue';
  import {useRouter, useRoute} from "vue-router";
  import {
    baseURL,
    downloadMajorTargetRank,
    getDisciplineInfo,
    getMajorEmploymentRate,
    getMajorTargetRank
  } from "@/network/axios";
  import * as echarts from "echarts";
  import {log} from "echarts/types/src/util/log";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DisciplinePage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();
  //学科门类
  let category: any = ref('');
  // 学历（本科、专科、职本）
  let type: any = ref('');
  category.value = route.params.category;
  type.value = route.params.type;

  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileDisciplinePage/' + category.value + '/' + type.value)
  }

  //判断是 本门类 还是 本大类
  let subjectName = () => {
    if (type.value == 1) {
      return '本门类'
    } else {
      return '本大类'
    }
  }


  let disciplineInfo: any = reactive({
    categories: '',
    type: '',
    details: '',
    //半年后月收入
    incomeArray: [
      {name: '', value: ''},
      {name: '', value: ''},
    ],
    // income: '',
    // incomeAvg: '',
    //毕业半年后的就业率
    rate: '',
    rateAvg: '',
    //留学比例
    studyAbordAvg: '',
    studyAbroad: '',
    //读研比例
    enterHigher: '',
    enterHigherAvg: '',
    //读研转专业比例
    enterCross: '',
    enterCrossrAvg: '',
    //工作与专业相关度
    relation: '',
    //毕业时掌握的基本工作能力
    ability: '',
    //基本工作能力满意度
    satisfaction: '',
    //自主创业比例
    setUp: '',
    //===============右半部分===============//
    //专业就业率排行榜
    // majorEmploymentRate: [],

    //专业（类）指标排行
    majorTargetRank: [],
  });

  // //获取右半部分 专业就业率排行榜
  // getMajorEmploymentRate('/majors/getEmRateRank', {
  //   params: {
  //     type: type.value
  //   }
  // }).then((res) => {
  //   disciplineInfo.majorEmploymentRate = [];
  //   disciplineInfo.majorEmploymentRate = res.data.data;
  // });
  // // 专业就业率排行榜 前三名颜色
  // let bgStyle = (n: number) => {
  //   if (n == 0) {
  //     return 'background:#d33336'
  //   } else if (n == 1) {
  //     return 'background:#dc6a6c'
  //   } else if (n == 2) {
  //     return 'background:#eabcbe'
  //   }
  // };
  //获取专业(类)指标排行榜
  let getMajorGroupRankFileName =()=>{
    let hierarchy:any =ref('');
    if (category.value>=1&&category.value<=12){
      hierarchy.value=1
    }else if (category.value>=32&&category.value<=50){
      hierarchy.value=3
    }else {
      hierarchy.value=2
    }
    getMajorTargetRank('/majors/getMajorGroupRankFileName',{
      params:{
        hierarchy:hierarchy.value
      }
    }).then((res) => {
      disciplineInfo.majorTargetRank = [];
      disciplineInfo.majorTargetRank = res.data.data
    });
  }
  getMajorGroupRankFileName()

  //下载专业(类)指标排行榜
  let downloadTargetRank = (fileName: any, route: any) => {
    window.open(baseURL+'/majors/downloadFile?fileName='+fileName+'&route='+route)
    // downloadMajorTargetRank('/majors/downloadFile', {
    //   params: {
    //     fileName: fileName,
    //     route: route,
    //   }
    // }).then((res) => {
    //   // console.log(res.data)
    //   downloadFile(res.data, fileName)
    // })
  };

  //下载
  let downloadFile = (data: any, fileName: any) => {
    if (!data) {
      return
    }
    //创建一个新的对象URL，该对象URL代表bold对象。
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    //给a标签 添加“下载”属性，文件名为：“value”
    link.setAttribute('download', fileName + '.pdf');
    document.body.appendChild(link);
    link.click();
  };


  onMounted(() => {
    getDisciplineInfo('/majors/getCategoriesDetails', {
      params: {
        category: category.value,
        type: type.value
      }
    }).then((res) => {
      // console.log(res.data);
      disciplineInfo.categories = res.data.data.categories;
      if (res.data.data.type == '普通本科') {
        disciplineInfo.type = '本科';
      } else if (res.data.data.type == '高职专科') {
        disciplineInfo.type = '专科';
      } else {
        disciplineInfo.type = res.data.data.type;
      }

      disciplineInfo.details = res.data.data.details;

      //半年后月收入
      if (res.data.data.income != '') {
        disciplineInfo.incomeArray[0].name = res.data.data.categories;
        disciplineInfo.incomeArray[0].value = res.data.data.income;
      } else {
        disciplineInfo.incomeArray[0].name = res.data.data.categories;
        disciplineInfo.incomeArray[0].value = '暂无数据';
      }
      if (res.data.data.incomeAvg != '') {
        disciplineInfo.incomeArray[1].name = res.data.data.type + '均值';
        disciplineInfo.incomeArray[1].value = res.data.data.incomeAvg;
      }else {
        disciplineInfo.incomeArray[1].name = res.data.data.type + '均值';
        disciplineInfo.incomeArray[1].value = '暂无数据';
      }
      // console.log(disciplineInfo.incomeArray)
      // disciplineInfo.income = res.data.data.income;
      // disciplineInfo.incomeAvg = res.data.data.incomeAvg;
      disciplineInfo.studyAbordAvg = res.data.data.studyAbroadAvg;
      disciplineInfo.studyAbroad = res.data.data.studyAbroad;
      disciplineInfo.enterHigher = res.data.data.enterHigher;
      disciplineInfo.enterHigherAvg = res.data.data.enterHigherAvg;
      disciplineInfo.enterCross = res.data.data.enterCross;
      disciplineInfo.enterCrossrAvg = res.data.data.enterCrossAvg;
      disciplineInfo.relation = res.data.data.relation;
      disciplineInfo.ability = res.data.data.ability;
      disciplineInfo.satisfaction = res.data.data.satisfaction;
      disciplineInfo.setUp = res.data.data.setUp;
      disciplineInfo.rate = res.data.data.rate;
      disciplineInfo.rateAvg = res.data.data.rateAvg;
      // console.log(disciplineInfo)
      nextTick(() => {
        if (route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line1Item1Echart') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              animation: false,
              //echart图 离容器的距离
              grid: {
                left: '1%',
                right: '19%',
                top: '6%',
                bottom: '-15%',
                containLabel: true
              },

              xAxis: [
                {
                  // x轴为 数值轴
                  type: 'value',
                  //不显示 数值
                  show: false,
                }
              ],
              yAxis: [
                {
                  //y轴 为类目轴
                  type: 'category',
                  //是否显示 坐标轴 轴线
                  axisLine: {
                    show: false
                  },
                  data: [disciplineInfo.incomeArray[1].name, disciplineInfo.incomeArray[0].name],
                  //是否显示 刻度
                  axisTick: {
                    show: false
                  },
                }
              ],
              series: [
                {
                  //类型 柱状图
                  type: 'bar',
                  //柱状图的宽度
                  barWidth: '9px',
                  emphasis: {
                    disabled: true,
                  },
                  //数据堆叠
                  // stack: 'Ad',

                  data: [
                    {
                      value: disciplineInfo.incomeArray[1].value,
                      // value:'100',
                      itemStyle: {
                        color: 'rgb(203,54,51)'
                      }
                    },
                    {
                      value: disciplineInfo.incomeArray[0].value,
                      // value: '100',
                      itemStyle: {
                        color: 'rgb(254,91,91)'
                      }
                    },
                  ],
                  itemStyle: {
                    borderRadius: [10, 10, 10, 10]
                  }
                },
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if (route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line1Item2EchartLeft') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#fd5b59', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,


                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.rate, name: '男'},
                    {value: 100 - disciplineInfo.rate, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if (route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line1Item2EchartRight') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#cd3532', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.rateAvg, name: '男'},
                    {value: 100 - disciplineInfo.rateAvg, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.relation == '' && disciplineInfo.ability == '' && disciplineInfo.satisfaction == '' && disciplineInfo.setUp == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line2Item1') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              animation: false,
              //echart图 离容器的距离
              grid: {
                left: '1%',
                right: '9%',
                top: '3%',
                bottom: '-6%',
                containLabel: true
              },

              xAxis: [
                {
                  // x轴为 数值轴
                  type: 'value',
                  //不显示 数值
                  show: false,
                }
              ],
              yAxis: [
                {
                  //y轴 为类目轴
                  type: 'category',
                  //是否显示 坐标轴 轴线
                  axisLine: {
                    show: false
                  },
                  data: ['自主创业比例', '基本工作能力满意度', '毕业时掌握的基本工作能力', '工作与专业相关度'],
                  //是否显示 刻度
                  axisTick: {
                    show: false
                  },
                }
              ],
              series: [
                {
                  //类型 柱状图
                  type: 'bar',
                  //柱状图的宽度
                  barWidth: '9px',
                  emphasis: {
                    disabled: true,
                  },
                  //数据堆叠
                  // stack: 'Ad',

                  data: [
                    {
                      value: disciplineInfo.setUp,
                      // value:'100',
                      itemStyle: {
                        color: 'rgb(254,91,91)'
                      }
                    },
                    {
                      value: disciplineInfo.satisfaction,
                      // value: '100',
                      itemStyle: {

                        color: 'rgb(254,91,91)'
                      }
                    },
                    {
                      value: disciplineInfo.ability,
                      // value: '100',
                      itemStyle: {

                        color: 'rgb(254,91,91)'
                      }
                    },
                    {
                      value: disciplineInfo.relation,
                      // value: '100',
                      itemStyle: {

                        color: 'rgb(254,91,91)'
                      }
                    },
                  ],
                  itemStyle: {
                    borderRadius: [10, 10, 10, 10]
                  }
                },
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.studyAbroad == '' && disciplineInfo.studyAbordAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart1') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#fd5b59', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.studyAbroad, name: '男'},
                    {value: 100 - disciplineInfo.studyAbroad, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.studyAbroad == '' && disciplineInfo.studyAbordAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart2') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#cd3532', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.studyAbordAvg, name: '男'},
                    {value: 100 - disciplineInfo.studyAbordAvg, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.enterHigher == '' && disciplineInfo.enterHigherAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart3') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#fd5b59', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.enterHigher, name: '男'},
                    {value: 100 - disciplineInfo.enterHigher, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.enterHigher == '' && disciplineInfo.enterHigherAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart4') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#cd3532', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],

                  avoidLabelOverlap: false,
                  // hoverAnimation: false,
                  emphasis: {
                    disabled: true,
                  },
                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.enterHigherAvg, name: '男'},
                    {value: 100 - disciplineInfo.enterHigherAvg, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.enterCross == '' && disciplineInfo.enterCrossrAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart5') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#fd5b59', '#e6e6e6'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.enterCross, name: '男'},
                    {value: 100 - disciplineInfo.enterCross, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
        if ((!(disciplineInfo.enterCross == '' && disciplineInfo.enterCrossrAvg == '')) && route.name == 'DisciplinePage') {
          (() => {
            let chartDom = document.getElementById('line3ItemEchart6') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              // trigger: 'item',
              // formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#cd3532', '#e6e6e6'],
              //关闭动画
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['65%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,
                  // hoverAnimation: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: disciplineInfo.enterCrossrAvg, name: '男'},
                    {value: 100 - disciplineInfo.enterCrossrAvg, name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
      })
    });
  })

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(disciplineInfo).categories), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            ((_unref(disciplineInfo).incomeArray[0].value=='暂无数据'&& _unref(disciplineInfo).incomeArray[1].value=='暂无数据'&&_unref(disciplineInfo).rate == ''&&_unref(disciplineInfo).rateAvg==''&&_unref(disciplineInfo).relation ==''&&_unref(disciplineInfo).ability ==''&&_unref(disciplineInfo).satisfaction==''&&_unref(disciplineInfo).setUp==''&&_unref(disciplineInfo).studyAbroad == ''&&_unref(disciplineInfo).studyAbordAvg==''&&_unref(disciplineInfo).enterHigher =='' &&_unref(disciplineInfo).enterHigherAvg==''&&_unref(disciplineInfo).enterCross == '' &&_unref(disciplineInfo).enterCrossrAvg==''&&_unref(disciplineInfo).details == ''))
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  "image-size": 180,
                  description: "暂无数据"
                }))
              : _createCommentVNode("", true),
            (!(_unref(disciplineInfo).details == ''))
              ? (_openBlock(), _createBlock(LeftTitle, {
                  key: 1,
                  title: "门类简介"
                }))
              : _createCommentVNode("", true),
            (!(_unref(disciplineInfo).details == ''))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(disciplineInfo).details), 1)
                ]))
              : _createCommentVNode("", true),
            (!(_unref(disciplineInfo).incomeArray[0].value=='暂无数据'&& _unref(disciplineInfo).incomeArray[1].value=='暂无数据'&&_unref(disciplineInfo).rate == ''&&_unref(disciplineInfo).rateAvg==''&&_unref(disciplineInfo).relation ==''&&_unref(disciplineInfo).ability ==''&&_unref(disciplineInfo).satisfaction==''&&_unref(disciplineInfo).setUp==''&&_unref(disciplineInfo).studyAbroad == ''&&_unref(disciplineInfo).studyAbordAvg==''&&_unref(disciplineInfo).enterHigher =='' &&_unref(disciplineInfo).enterHigherAvg==''&&_unref(disciplineInfo).enterCross == '' &&_unref(disciplineInfo).enterCrossrAvg==''))
              ? (_openBlock(), _createBlock(LeftTitle, {
                  key: 3,
                  title: "就业指标"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (!(_unref(disciplineInfo).incomeArray[0].value=='暂无数据'&& _unref(disciplineInfo).incomeArray[1].value=='暂无数据'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(disciplineInfo).incomeArray[0].value), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(disciplineInfo).incomeArray[1].value), 1)
                  ]))
                : _createCommentVNode("", true),
              (!(_unref(disciplineInfo).rate == ''&&_unref(disciplineInfo).rateAvg==''))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).rate==''?'暂无数据':_unref(disciplineInfo).rate+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(subjectName)()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).rateAvg == ''?'暂无数据':_unref(disciplineInfo).rateAvg+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).type+'均值'), 1)
                      ])
                    ]),
                    _hoisted_22
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!(_unref(disciplineInfo).relation ==''&&_unref(disciplineInfo).ability ==''&&_unref(disciplineInfo).satisfaction==''&&_unref(disciplineInfo).setUp==''))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(disciplineInfo).relation ==''? '暂无数据':_unref(disciplineInfo).relation+'%'), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(disciplineInfo).ability ==''?'暂无数据':_unref(disciplineInfo).ability+'%'), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(disciplineInfo).satisfaction==''?'暂无数据':_unref(disciplineInfo).satisfaction+'%'), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(disciplineInfo).setUp==''?'暂无数据':_unref(disciplineInfo).setUp+'%'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              (!(_unref(disciplineInfo).studyAbroad == ''&&_unref(disciplineInfo).studyAbordAvg==''))
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).studyAbroad == ''?
                      '暂无数据':_unref(disciplineInfo).studyAbroad+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(subjectName)()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).studyAbordAvg+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).type+'均值'), 1)
                      ])
                    ]),
                    _hoisted_36
                  ]))
                : _createCommentVNode("", true),
              (!(_unref(disciplineInfo).enterHigher =='' &&_unref(disciplineInfo).enterHigherAvg==''))
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).enterHigher ==''?
                      '暂无数据':_unref(disciplineInfo).enterHigher+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(subjectName)()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).enterHigherAvg+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).type+'均值'), 1)
                      ])
                    ]),
                    _hoisted_43
                  ]))
                : _createCommentVNode("", true),
              (!(_unref(disciplineInfo).enterCross == '' &&_unref(disciplineInfo).enterCrossrAvg==''))
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _hoisted_47,
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).enterCross == ''? '暂无数据':_unref(disciplineInfo).enterCross+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(subjectName)()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).enterCrossrAvg+'%'), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(disciplineInfo).type+'均值'), 1)
                      ])
                    ]),
                    _hoisted_50
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            (_unref(disciplineInfo).majorTargetRank.length>0)
              ? (_openBlock(), _createBlock(RightTitle, {
                  key: 0,
                  title: "专业(类)指标排行榜"
                }))
              : _createCommentVNode("", true),
            (_unref(disciplineInfo).majorTargetRank.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_el_form, {
                    "label-position": "right",
                    "label-width": "30px"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(disciplineInfo).majorTargetRank, (item) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, null, {
                          label: _withCtx(() => [
                            _hoisted_53
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              onClick: ($event: any) => (_unref(downloadTargetRank)(item.fileName,item.route))
                            }, _toDisplayString(item.fileName), 9, _hoisted_54)
                          ]),
                          _: 2
                        }, 1024))
                      }), 256))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode(_component_el_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "1." }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 本查询系统数据来源于教育部官网、阳光高考、各省教育考试院、各院校官网及招生就业网、软科官网、中国科教评价网、麦可思研究院等，数据仅供参考，具体数据请以学校官网或考试院最新公布为准。 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "2." }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 本站数据未经授权严禁转载，违者将依法追究责任。 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "3." }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 如对本系统或相关服务有任何疑问，可拨打电话400-018-0810反馈于我们。 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_58
        ])
      ])
    ])
  ]))
}
}

})